import "./BodhiButton.css";

const Spinner = () => (
	<span className="bodhi-btn-spinner" aria-hidden="true">
		<svg width="14" height="14" viewBox="0 0 14 14" fill="none">
			<title>Loading</title>
			<circle
				cx="7"
				cy="7"
				r="5.5"
				stroke="currentColor"
				strokeOpacity="0.25"
				strokeWidth="1.5"
			/>
			<path
				d="M12.5 7a5.5 5.5 0 0 0-5.5-5.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	</span>
);

const BodhiButton = ({
	children,
	variant = "primary",
	size = "md",
	icon,
	iconRight,
	loading = false,
	disabled = false,
	block = false,
	type = "button",
	className = "",
	...rest
}) => {
	const cls = [
		"bodhi-btn",
		`bodhi-btn-${variant}`,
		`bodhi-btn-${size}`,
		block && "bodhi-btn-block",
		loading && "bodhi-btn-loading",
		className,
	]
		.filter(Boolean)
		.join(" ");

	return (
		<button
			type={type}
			className={cls}
			disabled={disabled || loading}
			{...rest}
		>
			{loading && <Spinner />}
			{!loading && icon && <span className="bodhi-btn-icon">{icon}</span>}
			{children && <span className="bodhi-btn-label">{children}</span>}
			{iconRight && <span className="bodhi-btn-icon">{iconRight}</span>}
		</button>
	);
};

export default BodhiButton;
